module.exports = __webpack_public_path__ + "fonts/font.3e1bcd89.woff2";